import { render, staticRenderFns } from "./LoginView.vue?vue&type=template&id=1f4953b9&"
import script from "./LoginView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./LoginView.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports